import React, { Component } from 'react';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Button from '@material-ui/core/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import EditDayModal from './EditDayModal';
import { getWeekDayInitial } from '../../helpers';
import { COLORS } from '../../styles/colors';
import SaveOrCancel from '../SaveOrCancel';
import ButtonContent from '../ButtonContent';

export default class Builder extends Component {
	constructor(props) {
		super(props)
		this.state = {
			weeks: {},
			expanded: 0,
			selectedWeek: 0,
			selectedDay: 0,
			editingDay: false
		}
	}
	componentDidMount() {
		const { days } = this.props;
		console.log(days)
		let week = 1;
		let weekData = {};
		if (days) {
			const day_filter = (day) => (day.week.toString() === week.toString());
			const day_map = (day) => {
				weekData[week][day.day] = {
					...day
				}
				return day;
			};
			while (true) {
				let curWeek = days.filter((day) => day_filter(day));
				if (curWeek.length < 1) {
					break;
				}
				weekData[week] = {};

				Object.values(curWeek).map((curDay) => day_map(curDay))
				week++;
			}

			// Fixed for editing the workout
			let updateWeeks = {};
			for (let weeksKey in weekData) {
				const updateWeek = [1, 2, 3, 4, 5, 6, 7].map((day) => {
					const w = weekData[weeksKey];
					if (!w[day]) {
						w[day] = {
							workoutId: 0,
							rest: false,
							message: ''
						}
					}
					return w;
				});
				updateWeeks[weeksKey] = updateWeek.reduce((a, v) => ({ ...a, ...v }), {})
			}
			// Fixed for editing the workout
			console.log(updateWeeks);

			this.setState({
				...this.state,
				expanded: 1,
				weeks: updateWeeks
			})
		} else {
			this.addNewWeek();
		}

	}
	_addNewWeek() {
		let newWeek = {};
		[1, 2, 3, 4, 5, 6, 7].map((day, index) => {
			newWeek[day] = {
				workoutId: index % 2 ? 3 : 0,
				type: '',
				rest: !(index % 2),
				message: index % 2 ? '' : 'Rest Day ' + index,
			}
			return null;
		});

		const totalWeeks = Object.keys(this.state.weeks).length;
		this.setState({
			...this.state,
			expanded: totalWeeks + 1,
			weeks: {
				...this.state.weeks,
				[totalWeeks + 1]: newWeek
			}
		})
	}
	addNewWeek() {
		let newWeek = {};
		[1, 2, 3, 4, 5, 6, 7].map((day) => {
			newWeek[day] = {
				workoutId: 0,
				rest: false,
				message: ''
			}
			return null;
		});

		const totalWeeks = Object.keys(this.state.weeks).length;
		this.setState({
			...this.state,
			expanded: totalWeeks + 1,
			weeks: {
				...this.state.weeks,
				[totalWeeks + 1]: newWeek
			}
		})
	}
	removeWeek(removeKey) {
		const result = {};
		const { weeks } = this.state;
		let deletedWeek = {};
		let curWeek = 1;
		for (var week in weeks) {
			if (week !== removeKey) {
				result[curWeek] = weeks[week];
				curWeek = curWeek + 1;
			} else {
				deletedWeek = weeks[week];
			}
		}
		this.setState({ weeks: result, deletedWeek });
	}
	handleChange = (week, day) => event => {
		this.setState({
			...this.state,
			weeks: {
				...this.state.weeks,
				[week]: {
					...this.state.weeks[week],
					[day]: {
						...this.state.weeks[week][day],
						message: event.target.value
					}
				}
			}
		})
	}
	saveDay(data, toNextDay) {
		const { selectedDay, selectedWeek } = this.state;
		const { workouts } = this.props;
		console.log(workouts);
		const findWorkout = workouts[data.workoutId]
		this.setState({
			...this.state,
			weeks: {
				...this.state.weeks,
				[selectedWeek]: {
					...this.state.weeks[selectedWeek],
					[selectedDay]: {
						...data,
						workoutName: findWorkout ? findWorkout.name : ''
					}
				}
			}
		}, () => {
			var curDay = parseInt(selectedDay, 0) + 1;
			if (toNextDay && curDay < 8) {
				this.setState({
					...this.state,
					selectedDay: curDay
				})
			} else {
				this.setState({
					...this.state,
					selectedWeek: 0,
					selectedDay: 0,
					editingDay: false
				});
			}
		})
	}
	handleExpand(week) {
		this.setState(state => ({ expanded: state.expanded === week ? 0 : week }));
	}
	getEditItem() {
		const { selectedDay, selectedWeek, weeks } = this.state;
		if (weeks[selectedWeek]) {
			return weeks[selectedWeek][selectedDay];
		}
		return null;
	}
	editDay(day, week) {
		this.setState({
			...this.state,
			selectedDay: day,
			selectedWeek: week,
			editingDay: true
		})
	}

	fetchMore = (query) => {
		if(query.skip === 0) {
			this.props.resetWorkouts();
		}
		query.limit = 10;
		this.props.fetchMoreWorkouts(query)
	}

	displayDayInfo(day) {
		const { programWorkouts, workouts } = this.props;
		switch (day.type) {
			case "workout":
				const programWorkout = programWorkouts[day.workoutId] ? programWorkouts[day.workoutId] : null
				if (programWorkout) {
					return programWorkout.name;
				} else {
					const workout = workouts[day.workoutId] ? workouts[day.workoutId] : null
					if (workout) {
						return workout.name;
					} else {
						return day.workoutName;
					}
				}
			case "rest":
				return day.message ? "Rest Day: " + day.message : 'Rest Day';
			case "cardio":
				return day.message ? "Cardio Day: " + day.message : 'Please insert Cardio Day Information';
			default:
				return null;
		}
	}
	render() {
		const { weeks, expanded } = this.state;
		const { isValidating, validateForm, actionType, onCancel } = this.props;
		return (
			<div style={{ width: '100%', padding: 10 }}>
				<EditDayModal
					actionType={actionType}
					workouts={this.props.workouts}
					item={this.getEditItem()}
					opened={this.state.editingDay}
					save={(details, next) => this.saveDay(details, next)}
					close={() => {
						this.setState({
							...this.state,
							selectedWeek: 0,
							selectedDay: 0,
							editingDay: false
						})
						this.props.resetWorkouts();
					}}
					day={this.state.selectedDay}
					week={this.state.selectedWeek}
					cats={this.props.workoutCats}
					user={this.props.user}
					fetchMore={this.fetchMore}
					resetWorkouts = { this.props.resetWorkouts }
					isLoadMore={this.props.isLoadMore}
				/>
				<div>
					<span style={{ fontSize: 18, fontWeight: 'bolder' }}>{`Total weeks: ${Object.keys(weeks).length}`}</span>
				</div>
				{Object.keys(weeks).map((week, index) => (
					<ExpansionPanel
						style={{ width: '100%' }}
						key={`week-${week}`}
						expanded={expanded.toString() === week.toString()}
						onChange={() => this.handleExpand(week)}>
						<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
							<span>
								Week {week}
							</span>

						</ExpansionPanelSummary>
						<ExpansionPanelDetails style={{ flexDirection: 'column' }}>
							{Object.keys(weeks[week]).map((day) => (
								<div
									style={{
										justifyContent: 'space-between',
										padding: 5,
										height: 45,
										borderBottom: '3px solid ' + COLORS.grey
									}}
									className="listItem"
									key={'day-' + day} >
									<div style={{
										fontWeight: 'bold',
										width: '4%',
										borderRight: '1px solid ' + COLORS.grey,
										height: '100%',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center'
									}}>
										{getWeekDayInitial(day)}
									</div>
									<div style={{
										width: '90%',
										textAlign: 'center',
										overflow: 'hidden',
										textOverflow: 'ellipsis',
										whiteSpace: 'nowrap'
									}}>
										{this.displayDayInfo(weeks[week][day])}
									</div>
									<div
										onClick={() => this.editDay(day, week)}
										style={{ width: '5%' }}>
										<FontAwesomeIcon icon="edit"
											style={{
												float: 'right',
												marginRight: 5,
												color: COLORS.orange
											}} />
									</div>
								</div>

							))}
						</ExpansionPanelDetails>
						{
							((index + 1) > 1) ? (
								<ExpansionPanelDetails>
									<Button
										onClick={() => this.removeWeek(week)}
										variant="contained"
										color="primary"
										size="small"
										style={{ float: 'right', background: COLORS.red, margin: 5 }}
									>
										<ButtonContent
											text="Remove Week"
											icon="times"
										/>
									</Button>
								</ExpansionPanelDetails>
							) : null
						}

					</ExpansionPanel>
				))}
				<Button
					onClick={() => this.addNewWeek()}
					variant="contained"
					color="primary"
					size="small"
					style={{ background: COLORS.green, margin: 5 }}
				>
					<ButtonContent
						text="Add Week"
						icon="plus"
					/>
				</Button>
				<div style={{ padding: 10 }}>
					<SaveOrCancel
						saveDisabled={isValidating}
						onSaveClick={() => validateForm()}
						onCancelClick={onCancel}
					/>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/programs/Builder.js